export default __webpack_public_path__ + "static/media/lockedImg.7a8ead02.svg";